import { useFilterVehicleTransactionContext } from "./filter-vehicle-transaction.context";

export function FilterVehicleTransaction() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterVehicleTransactionContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}